import React from 'react'
import withSWR from './with-swr'
import {getTasks, TASKS_SWR_KEY} from '../backend'

const withTaskData = (Component, loaderText = 'Loading tasks...', refreshInterval = 0) => {
  return withSWR((props) => {
    return (<Component {...props}/>)
  }, {
    key: TASKS_SWR_KEY,
    fetcher: getTasks,
    mutateFuncKey: 'mutateTasks',
    loaderText,
    options: {refreshInterval},
    displayLoading: false
  })
}

export {withTaskData}

export default withTaskData